import { Link } from '@mui/joy';
import { createFileRoute } from '@tanstack/react-router';
import { Fragment } from 'react';

import { LegalHeading } from '@/components/legal/LegalHeading';
import { LegalText } from '@/components/legal/LegalText';
import { ObfuscatedEmail } from '@/components/legal/ObfuscatedEmail';
import { makeMetaTitle } from '@/modules/META';

export const Route = createFileRoute('/_content/barrierefreiheit')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
  head: () => ({
    meta: [makeMetaTitle(['Barrierefreiheit'])],
  }),
});

function RouteComponent() {
  return (
    <Fragment>
      <LegalHeading level="h1" sx={{ marginTop: 0 }}>
        Barrierefreiheit
      </LegalHeading>
      <LegalHeading>Einleitung</LegalHeading>
      <LegalText>
        Das Ministerium für Verkehr Baden-Württemberg ist bemüht, seine Web-Anwendungen und mobilen Anwendungen im
        Einklang mit § 12a des Landesbehindertengleichstellungsgesetzes (L-BGG) und der
        Barrierefreie-Informationstechnik-Verordnung (BITV 2.0) barrierefrei zugänglich zu machen.
      </LegalText>
      <LegalHeading>Stand der Vereinbarkeit mit den Anforderungen</LegalHeading>
      <LegalText>
        Diese Web-Anwendung ist teilweise mit § 12a L-BGG und der BITV 2.0 vereinbar. Einige Inhalte entsprechen noch
        nicht vollständig den Anforderungen.
      </LegalText>
      <LegalHeading>Nicht barrierefreie Inhalte</LegalHeading>
      <LegalText>Die nachstehend aufgeführten Inhalte sind aus den folgenden Gründen nicht barrierefrei:</LegalText>
      <LegalText component="ul">
        <li>
          <b>Unvereinbarkeit mit § 12a L-BGG und der BITV 2.0:</b>
          <LegalText component="ul">
            <li>Einige Bilder und Grafiken verfügen noch nicht über alternative Texte.</li>
            <li>Eingabeformulare fehlen teilweise noch beschreibende Labels.</li>
            <li>Kontrast- und Farbverhältnisse in der Kartenanwendung</li>
            <li>Fokus-Reihenfolge entspricht nicht der visuellen Anordnung</li>
          </LegalText>
        </li>
        <li>
          <b>Unverhältnismäßige Belastung:</b>
          <LegalText component="ul">
            <li>
              Eine vollständige Barrierefreiheit aller Dokumente und Multimedia-Inhalte kann aktuell aufgrund des hohen
              Aufwandes und der begrenzten Ressourcen nicht gewährleistet werden.
            </li>
          </LegalText>
        </li>
      </LegalText>

      <LegalHeading>Erstellung dieser Erklärung zur Barrierefreiheit</LegalHeading>
      <LegalText>
        Diese Erklärung wurde am 11.06.2024 erstellt und beruht auf einer durchgeführten Selbstbewertung. Die Erklärung
        wurde zuletzt am 30.07.2025 überprüft.
      </LegalText>

      <LegalHeading>Feedback und Kontaktangaben</LegalHeading>
      <LegalText>
        Sind Ihnen Mängel beim barrierefreien Zugang zu Inhalten unserer Website aufgefallen? Dann können Sie sich gerne
        bei uns melden.
      </LegalText>

      <LegalText>
        Telefon: 0711 89686-9100
        <br />
        E-Mail: <ObfuscatedEmail name="presse" />
      </LegalText>

      <LegalHeading>Durchsetzungsverfahren</LegalHeading>
      <LegalText>
        Falls auch nach Ihrem Feedback an den oben genannten Kontakt keine zufriedenstellende Lösung gefunden wurde,
        können Sie sich an die Landes-Behindertenbeauftragte wenden.
      </LegalText>

      <LegalText>
        Landes-Behindertenbeauftragte
        <br />
        Simone Fischer <br />
        Else-Josenhans-Straße 6<br />
        70173 Stuttgart
        <br />
        Telefon: +49 711 279-3360
        <br />
        E-Mail: <ObfuscatedEmail domain="bfbmb.bwl.de" name="poststelle" />
      </LegalText>

      <LegalText>
        Wenn Sie der Meinung sind, dass diese Webseite nicht barrierefrei zugänglich ist, können Sie unsere in Ziffer 4
        genannte Stelle oder Person darüber informieren.
      </LegalText>

      <LegalText>
        Falls wir Ihnen nicht oder nicht zufriedenstellend innerhalb von vier Wochen ab Zugang Ihrer Anfrage antworten,
        können Sie sich an die Schlichtungsstelle des Landeszentrums für Barrierefreiheit (LZ-BARR) wenden. Die
        Schlichtungsstelle erreichen Sie wie folgt:
      </LegalText>

      <LegalText>
        Landeszentrum Barrierefreiheit <br />
        Schlichtungsstelle <br />
        Else-Josenhans-Straße 6 <br />
        70173 Stuttgart <br />
        Telefon: 0711 123 39375 <br />
        E-Mail: <ObfuscatedEmail domain="barrierefreiheit.bwl.de" name="schlichtung" />
        <br />
        Webseite: <Link href="https://barrierefreiheit-bw.de/">www.barrierefreiheit-bw.de</Link>
      </LegalText>

      <LegalText>Das Schlichtungsverfahren ist unentgeltlich.</LegalText>

      <LegalText>
        Wir sind stets bemüht, die Barrierefreiheit unserer Website zu verbessern und freuen uns über Ihre Anmerkungen
        und Hinweise.
      </LegalText>
    </Fragment>
  );
}
